import { Product } from '../storage'
import { CATEGORY_DEFAULT_OPTION, SortingOptions } from '../../../util/consts'
import { sortProducts } from './sortProducts'
import { ProductFilters } from '../components/ProductFilter'
import { DateRangeType } from '../../../components/DateRangePicker'
import { FromTo } from '../../../components/Filters/types'

export const filterProducts = (
  data: Product[],
  selectedFilters: ProductFilters,
  sortBy: SortingOptions,
) => {
  const { category, searchText, dateRange, priceRange } = selectedFilters

  const filteredProducts = data.filter((product) => {
    if (!isCategoryValid(category, product)) {
      return false
    }

    if (!isSearchTextValid(searchText, product)) {
      return false
    }

    if (!isDateRangeValid(dateRange, product)) {
      return false
    }

    if (!isPriceRangeValid(priceRange, product)) {
      return false
    }

    return true
  })

  return sortProducts(filteredProducts, sortBy)
}

const isCategoryValid = (category: string, product: Product) => {
  return category === CATEGORY_DEFAULT_OPTION || product.category === category
}

const isSearchTextValid = (searchText: string, product: Product) => {
  return (
    searchText === '' ||
    product.description.toLowerCase().includes(searchText.toLowerCase()) ||
    product.itemNumber.includes(searchText) // SKU search
  )
}

const isDateRangeValid = (dateRange: DateRangeType, product: Product) => {
  if (dateRange.from === undefined || dateRange.to === undefined) {
    return true
  }

  let { from, to } = dateRange
  if (to < from) {
    ;[from, to] = [to, from]
  }

  const hasOrdersInRange = product.orders.some((order) => {
    const orderDate = new Date(order.createdAt)
    return orderDate >= from && orderDate <= to
  })

  return hasOrdersInRange
}

const isPriceRangeValid = (priceRange: FromTo<number>, product: Product) => {
  if (priceRange.from === undefined && priceRange.to === undefined) {
    return true
  }

  let from = priceRange.from ?? 0
  let to = priceRange.to

  if (to && from && to < from) {
    ;[from, to] = [to, from]
  }

  const isPriceInRange =
    (product.basePriceExcGst >= (from ?? 0) && (!to || product.basePriceExcGst <= to)) ||
    (product.discountedPriceExcGst >= (from ?? 0) && (!to || product.basePriceExcGst <= to))

  return isPriceInRange
}
